import { Singleton } from '@skylab-shared/utils';

export type CompanyContext = {
	tenantCorrelationId: string;
	companyIdentityId: number;
}

@Singleton
export class CompanyContextService {
	private _companyContext!: CompanyContext;

	public get companyContext(): CompanyContext {
		return this._companyContext;
	}

	public set companyContext(value: CompanyContext) {
		if (this._companyContext) return;

		this._companyContext = {...value};
	}
}

export const CompanyContextServiceBase = new CompanyContextService();
